import { render, staticRenderFns } from "./PatientInformation.vue?vue&type=template&id=22d615e9"
import script from "./PatientInformation.vue?vue&type=script&lang=js"
export * from "./PatientInformation.vue?vue&type=script&lang=js"
import style0 from "./PatientInformation.vue?vue&type=style&index=0&id=22d615e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports